var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.visible,
            title: _vm.$t("CargoMsg.Cargo_CreditControlInfo"),
            "show-close": true
          },
          on: { close: _vm.onClose }
        },
        [
          _c("cargo-ag-grid", {
            style: { width: "100%", height: "250px" },
            attrs: {
              "show-side-bar": false,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.dialogRowData,
              no: "1"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }